module.exports = __webpack_public_path__ + "img/7.01013be7.jpg";